module.exports = "/layout/app/images/bg-header-gray-lg.5436bb32.svg";